import { Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { UserRow } from "../../shared/types/user.types";

interface UserRowActionsProps {
  row: UserRow;
  onView: (row: UserRow) => void;
  onEdit: (row: UserRow) => void;
  onDelete: (row: UserRow) => void;
}

const iconButtonClass = "tw-h-8 tw-w-8";

/** "View profile" button plus edit / delete icons for one grid row. */
const UserRowActions = ({ row, onView, onEdit, onDelete }: UserRowActionsProps) => (
  <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
    <Button variant="outline" size="sm" className="tw-mr-1 tw-bg-muted/40" onClick={() => onView(row)}>
      View profile
    </Button>
    <Button variant="ghost" size="icon" className={iconButtonClass} title="Edit" onClick={() => onEdit(row)}>
      <Pencil className="tw-h-3.5 tw-w-3.5" />
    </Button>
    <Button
      variant="ghost"
      size="icon"
      className={`${iconButtonClass} tw-text-destructive hover:tw-text-destructive`}
      title="Delete"
      onClick={() => onDelete(row)}
    >
      <Trash2 className="tw-h-3.5 tw-w-3.5" />
    </Button>
  </div>
);

export default UserRowActions;
